<ng-template ngFor let-child let-i="index" [ngForOf]="root ? item : item.items">
  <li [ngClass]="{ 'active-menuitem': isActive(i) }" *ngIf="child.visible === false ? false : true">
    <a
      [href]="child.url || '#'"
      (click)="itemClick($event, child, i)"
      class="ripplelink"
      *ngIf="!child.routerLink"
      [attr.tabindex]="!visible ? '-1' : null"
      [attr.target]="child.target"
    >
      <!--      <i class="material-icons">{{ child.icon }}</i>-->
      <span>{{ child.label }}</span>
      <i class="material-icons" *ngIf="child.items">keyboard_arrow_down</i>
    </a>

    <a
      (click)="itemClick($event, child, i)"
      class="ripplelink"
      *ngIf="child.routerLink"
      [routerLink]="child.routerLink"
      routerLinkActive="active-menuitem-routerLink"
      [routerLinkActiveOptions]="{ exact: true }"
      [attr.tabindex]="!visible ? '-1' : null"
      [attr.target]="child.target"
    >
      <!--      <i class="material-icons">{{ child.icon }}</i>-->
      <span>{{ child.label }}</span>
      <i class="material-icons" *ngIf="child.items">keyboard_arrow_down</i>
      <i
        class="fa fa-thumb-tack menu-pin"
        *ngIf="menuPinService.enabled && !child.items"
        [class.pinned]="menuPinService.isPinned(child.routerLink[0])"
        [title]="menuPinService.isPinned(child.routerLink[0]) ? 'Unpin' : 'Pin to top'"
        (click)="menuPinService.toggle($event, child.routerLink[0])"
      ></i>
    </a>
    <ul
      app-submenu
      [item]="child"
      *ngIf="child.items"
      [@children]="isActive(i) ? 'visible' : 'hidden'"
      [visible]="isActive(i)"
      [reset]="reset"
    ></ul>
  </li>
</ng-template>
